import initialState from "./taxAdjustment.state.js";
import actions from "./taxAdjustment.actions.js";
import mutations from "./taxAdjustment.mutations.js";
import getters from "./taxAdjustment.getters.js";

export default {
  state: initialState,
  actions,
  mutations,
  getters
};
